// store/auth.js

// import * as dashboard from './user';
import axios from "axios";
import { apis } from '../../apis/superAdmin';
// import router from "../../../router/index";
// import store from '@/store';

const state = {
    // Additional state if needed
    getUsersToken: '',
}

const mutations = {
    SET_USERS_DATA(state, data) {
        state.getUsersToken = data?.users
    },
}

const actions = {
    // Additional actions if needed
    getUsersTokensSuperAdmin({ commit }) {
        // return
        // return new Promise((resolve, reject) => {
        axios
            .get(axios.defaults.baseURL + apis.GET_USERTOKENS, {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                    "ngrok-skip-browser-warning": "69420",
                },
            })
            .then((res) => {
                console.log('getUsersTokensSuperAdmin---res !!', res)
                if (res.data.data) {
                    commit('SET_USERS_DATA', res.data.data)
                }
                else {
                    commit('SET_USERS_DATA', res.data.message)
                }
            })
            .catch((err) => {
                console.log('getUsersTokensSuperAdmin err', err)
            })
        // })
    },

}

const getters = {
    // Additional getters if needed
}

export default {
    state,
    mutations,
    actions,
    getters,
};